import React from "react"

const InformationIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9Z" stroke="#606060" stroke-width="1.5" />
            <path d="M9.18164 12.75V9C9.18164 8.64645 9.18164 8.46967 9.07181 8.35983C8.96197 8.25 8.78519 8.25 8.43164 8.25" stroke="#606060" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.994 6H9.00073" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default InformationIcon